/**
 * Created by Todd Yu 05/26/2020
 *
 * Filter used for keyword search in admin-pages component
 *
 */

import { Pipe, PipeTransform } from '@angular/core';
import * as _lodash from 'lodash';

@Pipe({ name: 'adminPageFilter' })
export class AdminPageFilter implements PipeTransform {
    transform(adminPages: any[], keyword: string): any {
        if (!adminPages || keyword === '') {
            return adminPages;
        }
        keyword = keyword.toLowerCase();

        const pages = _lodash.cloneDeep(adminPages);
        pages.forEach(page => {
            page[1] = page[1].filter(item => item.id.toLowerCase().indexOf(keyword.toLowerCase()) > -1);
        });
        return pages;
    }
}
